import React from "react";
import MintTile from "./MintTile";
import * as s from "../../styles/components/Tile/tileStyle";

const Tile = () => {
    return (
        <s.ResponsiveWrapper flex={1} style={{ 
          padding: 24,
          justifyContent:'center', 
          alignItems:'center',
          height: '80vh'
         }}>
          <s.Container
            flex={.3}
            jc={"center"}
            ai={"center"}
            >
            <MintTile></MintTile>
          </s.Container>
        </s.ResponsiveWrapper>
    )
}

export default Tile